import { Router, Route, Switch } from "react-router-dom";
import "./components/theme/less/theme.less";
import { GlobalProvider } from "./services/provider/Global.provider";
import { createBrowserHistory } from "history";
import "src/components/theme/scss/common.scss";
import { LoadStaticScripts } from "./StaticScripts";
import { Suspense, lazy } from "react";
import Loading from "src/components/common/Loading";
import "./App.css";
import { ServiceProvider } from "./services/provider/Service.provider";
import { SecureProvider } from "./services/provider/Secure.provider";
import { MenuUrlEnum } from "./components/common/side-menu/MenuUrlEnum";
import { History } from 'history';
import { ConfigProvider } from "antd";
import ptBR from "antd/locale/pt_BR";

const Admin = lazy(() => import("./pages/Routers"));
const history: History<any> = createBrowserHistory();
LoadStaticScripts(history);

const App = () => {
  return (
    <Router history={history}>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route path={MenuUrlEnum.BaseUrl} component={Admin} />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default (props: any) => (
  <ConfigProvider locale={ptBR}>
    <ServiceProvider formInstance={null} history={history}>
      <SecureProvider>
        <GlobalProvider>
          <App {...props} />
        </GlobalProvider>
      </SecureProvider>
    </ServiceProvider>
  </ConfigProvider>
);
